/* Coco 9 — Occasion switching + complimentary card block.
 *
 * Loaded on every product page; a complete no-op unless the page rendered
 * an occasion data island. Never throws — personalisation must not break
 * add-to-cart.
 *
 * Active-occasion priority (customizable products):
 *   1. ?occasion= URL param   (applied here, on top of SSR)
 *   2. collection context      (already resolved server-side)
 *   3. product default         (already resolved server-side)
 *   4. first presentation      (already resolved server-side)
 */
(function(){
  'use strict';
  var $ = function(s, r){ return (r||document).querySelector(s); };
  var $$ = function(s, r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); };
  function setVal(el, v){ if(el) el.value = (v == null ? '' : v); }

  // ── Customizable: occasion selector ───────────────────────────
  (function(){
    var island = $('[data-oc-data]');
    if(!island) return;
    var data;
    try { data = JSON.parse(island.textContent); } catch(e){ return; }
    if(!data || !data.presentations) return;

    var map = {};
    data.presentations.forEach(function(p){ map[p.key] = p; });

    var heroImg  = $('[data-gallery-main]');
    var titleEl  = $('[data-oc-title]');
    var subEl    = $('[data-oc-subtitle]');
    var chips    = $$('[data-oc-chip]');
    var cpImg    = $('[data-oc-cardpreview-img]');
    var cpTitle  = $('[data-oc-cardpreview-title]');
    var pkgEl    = $('[data-oc-pkg]');
    var propLabel= $('[data-oc-prop-label]');
    var propKey  = $('[data-oc-prop-key]');
    var propImg  = $('[data-oc-prop-image]');
    var propPkg  = $('[data-oc-prop-pkg]');

    function apply(key, pushUrl){
      var d = map[key];
      if(!d) return;
      if(heroImg && d.hero){ heroImg.src = d.hero; heroImg.alt = d.title || ''; }
      if(titleEl && d.title){ titleEl.textContent = d.title; }
      if(subEl){ subEl.textContent = d.subtitle || ''; subEl.hidden = !d.subtitle; }
      chips.forEach(function(c){ c.setAttribute('aria-pressed', c.getAttribute('data-oc-key') === key ? 'true' : 'false'); });
      if(cpImg && d.card){ cpImg.src = d.card; }
      if(cpTitle){ cpTitle.textContent = d.label || ''; }
      if(pkgEl){ pkgEl.textContent = d.packaging || ''; }
      setVal(propLabel, d.label);
      setVal(propKey, key);
      setVal(propImg, d.hero || d.card || '');
      setVal(propPkg, d.packaging);
      if(pushUrl){
        try { var u = new URL(window.location.href); u.searchParams.set('occasion', key); history.replaceState(null, '', u); } catch(e){}
      }
    }

    chips.forEach(function(c){
      c.addEventListener('click', function(){ apply(c.getAttribute('data-oc-key'), true); });
    });

    var ssrActive = island.getAttribute('data-oc-active') || '';
    var urlKey = '';
    try { urlKey = new URL(window.location.href).searchParams.get('occasion') || ''; } catch(e){}
    var initKey = (urlKey && map[urlKey]) ? urlKey : ssrActive;
    if(initKey && map[initKey]){ apply(initKey, false); }
  })();

  // ── Universal: complimentary card block ───────────────────────
  (function(){
    var block = $('[data-oc-cardblock]');
    if(!block) return;
    var toggle = $('[data-oc-cardtoggle]', block);
    var fields = $('[data-oc-cardfields]', block);
    var occSel = $('[data-oc-cardocc]', block);
    var designsWrap = $('[data-oc-designs]', block);
    var designProp = $('[data-oc-design-prop]', block);
    var cardsIsland = $('[data-oc-cards]', block);
    var cards = {};
    if(cardsIsland){ try { cards = JSON.parse(cardsIsland.textContent) || {}; } catch(e){ cards = {}; } }

    function setDisabled(dis){
      if(!fields) return;
      $$('[name^="properties"]', fields).forEach(function(el){ el.disabled = dis; });
    }
    function reveal(){
      var on = !!(toggle && toggle.checked);
      if(fields){ fields.hidden = !on; }
      setDisabled(!on);
    }
    if(toggle){ toggle.addEventListener('change', reveal); }

    function renderDesigns(occKey){
      if(!designsWrap) return;
      var list = cards[occKey] || [];
      designsWrap.innerHTML = '';
      setVal(designProp, '');
      if(!list.length){ designsWrap.setAttribute('hidden', ''); return; }
      designsWrap.removeAttribute('hidden');
      list.forEach(function(card, i){
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'oc-design';
        b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
        b.innerHTML = (card.img ? '<img src="' + card.img + '" alt="" loading="lazy">' : '') + '<span>' + (card.title || '') + '</span>';
        b.addEventListener('click', function(){
          $$('.oc-design', designsWrap).forEach(function(x){ x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          setVal(designProp, card.title || '');
        });
        designsWrap.appendChild(b);
      });
      setVal(designProp, list[0].title || '');
    }

    if(occSel){
      occSel.addEventListener('change', function(){ renderDesigns(occSel.value); });
      renderDesigns(occSel.value);
    }
    reveal();
  })();
})();
